import ApiConnector from "../apiConnector";
import { ServiceTeamItem } from "../entities/ServiceTeams/ServiceTeamItem";

class ServiceTeamsFetcher {
    private readonly apiConnector: ApiConnector;

    private readonly baseEndpoint: string = "serviceTeams";

    constructor(baseURL: string) {
        this.apiConnector = new ApiConnector(baseURL);
    }

    public async getServiceTeams(): Promise<ServiceTeamItem[]> {
        return await this.apiConnector.get<ServiceTeamItem[]>(`${this.baseEndpoint}/`);        
    }

    public async getServiceTeamById(id: string): Promise<ServiceTeamItem> {
        return await this.apiConnector.get<ServiceTeamItem>(`${this.baseEndpoint}/${id}`);        
    }

    public async createServiceTeam(team: ServiceTeamItem): Promise<void> {
        return await this.apiConnector.post<void>(`${this.baseEndpoint}/`, team);
    }

    public async updateServiceTeam(team: ServiceTeamItem): Promise<void> {
        return await this.apiConnector.put<void>(`${this.baseEndpoint}/${team.id}`, team);
    }
    public async deleteServiceTeam(id: string): Promise<void> {
        return await this.apiConnector.delete<void>(`${this.baseEndpoint}/${id}`);
    }
}

export default ServiceTeamsFetcher;